/**
 * Sub1 Template
 * @category testApp
 */
class BasicInfoTempl {
    /**
     * Sub1 Templ
     * @param  {Object} _d={}
     */
    /*

  <a href="" role="button" class="btn-character-thumbnail-change">
              <iframe src="/common/emblem_upload.html" frameborder="0" name="${characterProfileImg}"></iframe>
              <span class="blind">사진 변경</span>
            </a>
    * */
    static getTempl(_d={}, _config={}) {
        let guildLink;
        if(_d.guild){
            guildLink ='/world/guild/'+_d.serverType+'/'+_d.serverId+'/'+_d.guild.guildName;
        }
        let characterProfileImg = _config.profileImg +_d.profileImageUrl+'&serverType='+_config.serverType;
        return `
	    <div class="character-thumbnail-wrap">
            <span class="character-thumbnail"><img src="${characterProfileImg}" alt="" width="90" height="90"></span>
            ${_config.isMyCharacter ? `
            <form class="imageUploadForm" style="width:30px;height:30px;">
    <label class="fileUploadInput">
        <input type="file" name="attachment" accept="image/*" data-info="${ '&charKey=' + _config.characterId + '&serverId=' + _config.serverId + '&serverType=' + _config.serverType}">
    </label>
</form>
            `: ``}
        </div>
        <div class="character-name-wrap">
            <strong class="character-name"><span>${_d.name}</span>${_config.isMyCharacter ? `<button class="btn-character-name"><span class="blind">캐릭터 리스트 보기</span><svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6"><g fill="none" fill-rule="evenodd" stroke="#494949" stroke-linecap="square"><path d="M.41 1.034l4.518 4.438M9.76 1.034L5.242 5.472"/></g></svg></button>`:``}</strong>
            <div class="character-list-layer">
                <ul class="character-list"></ul>
                <div class="loading-wrap is-show">
                    <div class="loading"></div>
                </div>
                <button class="btn-close-layer"><span class="blind">닫기</span><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"><g fill="none" fill-rule="evenodd" stroke="#1F1F1F" stroke-linecap="square" stroke-width=".5"><path d="M1.051 1.051l17.55 17.55M1.051 18.601l8.754-8.753 6.78-6.782 2.016-2.015"/></g></svg></button>
            </div>
        </div>
        <div class="character-sub-info-wrap">
            <span class="character-sub-info">${_d.jobName}</span>
            <span class="character-sub-info">${_d.serverName}</span>
            <span class="character-sub-info"><em>Lv.${_d.level}</em>${_d.masteryFactionName ? `<em>${_d.masteryFactionName}${_d.masteryLevel}성</em>` : ``}</span>
        </div>
        ${(_d.factionName || _d.guild) ? 
            `<div class="character-sub-info-wrap">
                ${_d.factionName ?  `<span class="character-sub-info">${_d.factionName}</span>` : ``}
                ${_config.isMyCharacter && _d.guild ?  `<a href="${guildLink}" class="character-sub-info">${_d.guild.guildName}</a>` : ``}
            </div>`
        :``}
        ${!(_config.isMyCharacter) ?`<div class="character-sub-btn-wrap"><button class="btn-gift"><span class="flag-gift">선물</span></button></div>`:''}        
        `;
    }
} // end of class

export default BasicInfoTempl;
